import { render, staticRenderFns } from "./TablePlanoTrabalho.vue?vue&type=template&id=067a3c5c&"
import script from "./TablePlanoTrabalho.vue?vue&type=script&lang=js&"
export * from "./TablePlanoTrabalho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports